"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenMessages = exports.getAsset = exports.getLogLevel = exports.formatDate = exports.addLeadingZero = exports.getRandomIndex = exports.checkIsMobile = exports.getTimerDetails = exports.handleClassNames = exports.addTrailingZero = exports.debounce = exports.beautifyUserId = void 0;
var configurations_1 = __importDefault(require("./configurations"));
var beautifyUserId = function (userId, isYou) {
    if (isYou) {
        return "YOU";
    }
    return userId.replace(/\*+/, "•••");
};
exports.beautifyUserId = beautifyUserId;
var debounce = function (func, time) {
    if (time === void 0) { time = 100; }
    var timer;
    return function (event) {
        timer && clearTimeout(timer);
        timer = setTimeout(func, time, event);
    };
};
exports.debounce = debounce;
var addTrailingZero = function (value) {
    if (~~value < 10) {
        return "0".concat(value);
    }
    return value;
};
exports.addTrailingZero = addTrailingZero;
var handleClassNames = function (baseClassName, extraClassNames) {
    if (extraClassNames) {
        return [baseClassName, extraClassNames].join(" ");
    }
    return baseClassName;
};
exports.handleClassNames = handleClassNames;
var getTimerDetails = function (seconds) {
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);
    hours = hours - days * 24;
    minutes = minutes - days * 24 * 60 - hours * 60;
    var remainingSeconds = Math.floor(seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60);
    return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: remainingSeconds,
    };
};
exports.getTimerDetails = getTimerDetails;
var checkIsMobile = function (userAgent) {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
            // eslint-disable-next-line no-useless-escape
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
    })(userAgent || navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
exports.checkIsMobile = checkIsMobile;
var getRandomIndex = function (max, min) {
    if (min === void 0) { min = 0; }
    return ~~(Math.random() * (max - min) + min);
};
exports.getRandomIndex = getRandomIndex;
var addLeadingZero = function (item) {
    if (item < 10) {
        return "0".concat(item);
    }
    else {
        return item.toString();
    }
};
exports.addLeadingZero = addLeadingZero;
var formatDate = function (date) {
    var parsed = new Date(date);
    var year = parsed.getFullYear(), month = (parsed.getMonth()) + 1, day = parsed.getDate(), hours = parsed.getHours(), minutes = parsed.getMinutes();
    return "".concat(year, "-").concat((0, exports.addLeadingZero)(month), "-").concat((0, exports.addLeadingZero)(day), " ").concat((0, exports.addLeadingZero)(hours), ":").concat((0, exports.addLeadingZero)(minutes));
};
exports.formatDate = formatDate;
var getLogLevel = function () { return (0, configurations_1.default)().logLevel; };
exports.getLogLevel = getLogLevel;
var getAsset = function (assets, assetType, filters) {
    return assets.find(function (asset) {
        return asset.type === assetType &&
            asset.lang === (filters === null || filters === void 0 ? void 0 : filters.lang) &&
            asset.currency === (filters === null || filters === void 0 ? void 0 : filters.currency) &&
            asset.brandId === (filters === null || filters === void 0 ? void 0 : filters.brandId) &&
            asset.customerId === (filters === null || filters === void 0 ? void 0 : filters.customerId);
    });
};
exports.getAsset = getAsset;
var flattenMessages = function (nestedMessages, prefix) {
    if (prefix === void 0) { prefix = ""; }
    if (nestedMessages === null) {
        return {};
    }
    return Object.keys(nestedMessages).reduce(function (messages, key) {
        var _a;
        var value = nestedMessages[key];
        var prefixedKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if (typeof value === "string") {
            Object.assign(messages, (_a = {}, _a[prefixedKey] = value, _a));
        }
        else {
            Object.assign(messages, (0, exports.flattenMessages)(value, prefixedKey));
        }
        return messages;
    }, {});
};
exports.flattenMessages = flattenMessages;
